import React from 'react';

const TrackVASContext = React.createContext();

export default TrackVASContext;
